import { compose } from "redux";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../../models/Action";
import { immutableSet } from "../../../../utils/immutable";
import { actionTypes } from "./actions";
import { LIST_IDENTIFIER, STATE_IDENTIFIER } from "./constants";
import emptyState from "./emptyState";
import { IDENTITY_SYSTEM } from "../../../../module/constants";

const {
  STEP_ONE,
  LOADER_IDENTIFIER,
  RESPONSE_STATE,
  ALL_USERS,
  SELECTED_USERS,
  TOTAL_ENTITLEMENTS,
  ADDED_ENTITLEMENTS,
  DELETED_ENTITLEMENTS,
  MODIFIED_ENTITLEMENTS,
  STEP_THREE,
  PREV_ENTITLEMENTS,
  EXISTING_SAME_DB,
  ENTITLEMENTS,
  DATE_ENTITLEMENTS,
  START_END_DATE,
  SOD_CONFLICTS,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.RECOVERY_POINT_RESET_STATE]: (state: any, action: any) =>
    emptyState,

  [actionTypes.GET_ALL_RECOVERY_POINT_USERS]: (state: any, action: any) =>
    immutableSet([LOADER_IDENTIFIER], true)(state),
  [actionTypes.GET_ALL_RECOVERY_POINT_USERS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let data = {
      pageNumber: action.payload.pageNumber,
      totalElements: action.payload.totalElements,
      pageTotalNumber: action.payload.pageTotalNumber,
      pageSize: action.payload.pageSize,
      responseCode: action.payload.responseCode,
      responseStatus: action.payload.responseStatus,
      users: [] as any[],
    };
    action.payload.users.forEach((usr: any) => {
      data.users.push({
        uniqueId: usr.id,
        code: usr.code,
        name: usr.name,
        surname: usr.surname,
        email: usr.email,
        organizational_unit_code: usr.organizational_unit_code,
        organizational_unit: usr.organizational_unit,
        resp_code: usr.resp_code,
        type: usr.type,
        company: usr.company,
        fullname: usr.fullname,
        supervisorFullName: usr.supervisorFullName,
        identitySystemId: usr.identitySystemId,
      });
    });
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([ALL_USERS], data)
    )(state);
  },
  [actionTypes.GET_ALL_RECOVERY_POINT_USERS_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([ALL_USERS], [])
    )(state);
  },
  [actionTypes.SET_RECOVERY_POINT_SELECTED_USERS]: (state: any, action: any) =>
    compose(immutableSet([SELECTED_USERS], action.payload))(state),

  [actionTypes.RECOVERY_POINT_MODIFY_TOTAL_ABILITATIONS]: (
    state: any,
    action: any
  ) =>
    compose(immutableSet([TOTAL_ENTITLEMENTS], action.totalAbilitations))(
      state
    ),

  [actionTypes.RECOVERY_POINT_MODIFY_ADDED_ABILITATIONS]: (
    state: any,
    action: any
  ) => immutableSet([ADDED_ENTITLEMENTS], action.addedAbilitations, state),

  [actionTypes.RECOVERY_POINT_MODIFY_DELETED_ABILITATIONS]: (
    state: any,
    action: any
  ) => immutableSet([DELETED_ENTITLEMENTS], action.deletedAbilitations, state),

  [actionTypes.RECOVERY_POINT_MODIFY_MODIFIED_ABILITATIONS]: (
    state: any,
    action: any
  ) =>
    immutableSet([MODIFIED_ENTITLEMENTS], action.modifiedAbilitations, state),

  [actionTypes.RECOVERY_POINT_MODIFY_TOTAL_ABILITATIONS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [STEP_THREE, TOTAL_ENTITLEMENTS],
      action.totalAbilitations,
      state
    ),
  [actionTypes.RECOVERY_POINT_USERS_ENTITLEMENT_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [STEP_THREE, PREV_ENTITLEMENTS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.RECOVERY_POINT_USERS_ENTITLEMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let objToReturn = {
      entitlements: action.payload.entitlements,
      businessRoles: action.payload.businessRoles,
    };
    return compose(
      immutableSet(
        [STEP_THREE, PREV_ENTITLEMENTS, LIST_IDENTIFIER],
        objToReturn
      ),
      immutableSet([STEP_THREE, PREV_ENTITLEMENTS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_THREE, TOTAL_ENTITLEMENTS], objToReturn)
    )(state);
  },

  [actionTypes.RECOVERY_POINT_USERS_ENTITLEMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([STEP_THREE, PREV_ENTITLEMENTS, LIST_IDENTIFIER], {
        businessRoles: [],
        entitlements: [],
      }),
      immutableSet([STEP_THREE, PREV_ENTITLEMENTS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_THREE, TOTAL_ENTITLEMENTS], [])
    )(state),

  [actionTypes.RECOVERY_POINT_SET_EXISTING_SAME_DB]: (
    state: any,
    action: any
  ) => immutableSet([EXISTING_SAME_DB], action.payload, state),

  [actionTypes.RECOVERY_POINT_GET_DATE_ABILITATIONS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [STEP_THREE, DATE_ENTITLEMENTS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.RECOVERY_POINT_GET_DATE_ABILITATIONS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let data: any[] = [];
    action.payload.entitlements.forEach((ab: any) => {
      data.push({
        entitlement_id: ab.entitlement_id,
        application_name: ab.application_name,
        application_description: ab.application_description,
        application_id: ab.application_id,
        entitlement_name: ab.entitlement_name,
        entitlement_description: ab.entitlement_description,

        identity_system_id: ab.identity_system_id,
        isMonoprofilo: ab.isMonoprofilo,
        involvedInSOD: ab.isInvolvedInSod,
        identitySystemId:
          IDENTITY_SYSTEM[
            (ab.identity_system_id ||
              ab.identitySystem) as keyof typeof IDENTITY_SYSTEM
          ],
      });
    });
    return compose(
      immutableSet([STEP_THREE, DATE_ENTITLEMENTS, LIST_IDENTIFIER], data),
      immutableSet([STEP_THREE, DATE_ENTITLEMENTS, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.RECOVERY_POINT_GET_DATE_ABILITATIONS_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([STEP_THREE, DATE_ENTITLEMENTS, LIST_IDENTIFIER], {
        entitlements: [],
      }),
      immutableSet([STEP_THREE, DATE_ENTITLEMENTS, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.REC_P_SET_START_END_DATE]: (state: any, action: any) => {
    let obj = {
      id: action.payload.id,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    };

    let data: any[] = state.stepThree.dateEntitlements.startEndDates;
    data.push(obj);
    return immutableSet(
      [STEP_THREE, DATE_ENTITLEMENTS, START_END_DATE],
      data,
      state
    );
  },

  [actionTypes.RECOVERY_POINT_CREATE_REQUEST]: (state: any, action: any) =>
    immutableSet([RESPONSE_STATE], IResponseState.PENDING, state),
  [actionTypes.RECOVERY_SOD_CONFLICTS]: (state: any, action: any) =>
    immutableSet([SOD_CONFLICTS], null, state),

  [actionTypes.RECOVERY_SOD_CONFLICTS_SUCCESS]: (state: any, action: any) =>
    immutableSet([SOD_CONFLICTS], action.payload, state),

  [actionTypes.RECOVERY_SOD_CONFLICTS_FAILURE]: (state: any, action: any) =>
    immutableSet([SOD_CONFLICTS], IResponseState.ERROR, state),

  [actionTypes.RECOVERY_RESET_SOD_CONFLICTS]: (state: any, action: any) =>
    immutableSet([SOD_CONFLICTS], null, state),

  [actionTypes.RECOVERY_POINT_CREATE_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([RESPONSE_STATE], IResponseState.ERROR, state),
  [actionTypes.RECOVERY_POINT_CREATE_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([RESPONSE_STATE], IResponseState.SUCCESS, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
